export default __webpack_public_path__ + "static/media/date-time.3cb5f942.svg";